import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TabViewModule } from 'primeng/tabview';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { TooltipModule } from 'primeng/tooltip';
import { ProgressBarModule } from 'primeng/progressbar';
import { TagModule } from 'primeng/tag';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { DropdownModule } from 'primeng/dropdown';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { DialogModule } from 'primeng/dialog';
import { SplitButtonModule } from 'primeng/splitbutton';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { ChartModule } from 'primeng/chart';
import { DialogService } from 'primeng/dynamicdialog';

import { WatchComponent } from '../watch/watch.component';
import { NotificationDialogComponent } from '../notification-dialog/notification-dialog.component';
import { MergenDialogComponent } from '../merge-dialog/merge-dialog.component';
import { DocApprovalComponent } from '../doc-approval/doc-approval.component';

@Component({
  selector: 'app-doc-history',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    TabViewModule,
    TagModule,
    ProgressBarModule,
    DropdownModule,
    TableModule,
    ButtonModule,
    RippleModule,
    TooltipModule,
    ConfirmDialogModule,
    ToastModule,
    OverlayPanelModule,
    SplitButtonModule,
    InputTextModule,
    CheckboxModule,
    ChartModule,
    WatchComponent,
    NotificationDialogComponent,
    MergenDialogComponent
  ],
  providers: [ConfirmationService, MessageService, DialogService],
  templateUrl: '../doc-approval/doc-approval.component.html',
  styleUrls: ['../doc-approval/doc-approval.component.scss']
})
export class DocHistoryComponent extends DocApprovalComponent {
  override classMode: 0 | 1 = 1;
}
